import { IAnalyticsTagManager } from '../../../domain/analytics/analytics-configuration'
import { ComScore } from './comscore'
import { GTM } from './gtm'

export interface ITagManager {
    init(tags: IAnalyticsTagManager): any
}

export class TagManager implements ITagManager {
    /**
     * Initialize Google Tag Manager
     */
    public init(tags: IAnalyticsTagManager): void {
        if (tags.gtm && tags.gtm.length > 0) {
            const gtm = new GTM()
            tags.gtm.forEach((account: string) => {
                gtm.init(account)
            })
        }

        if (tags.comScore) {
            const comscore = new ComScore()
            comscore.init(tags.comScore)
        }
    }
}
